<template>
  <div class="container">
    <el-row class="sale-module-query-search flex flex-align-center">
      <div
        class="select-wrap flex flex-align-center"
        @click="$router.push('/sale/mall/home')"
      >
        <el-button type="text" icon="el-icon-arrow-left">工厂款</el-button>
      </div>
      <div class="select-wrap flex flex-align-center">
        <label>风格</label>
        <el-select
          v-model="queryOpt.where.styleIds"
          :popper-append-to-body="false"
          placeholder="全部"
          multiple
          size="small"
          clearable
        >
          <el-option
            v-for="item in config.styles"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="select-wrap flex flex-align-center">
        <label>材质</label>
        <el-select
          v-model="queryOpt.where.materialIds"
          :popper-append-to-body="false"
          placeholder="全部"
          multiple
          size="small"
        >
          <el-option
            v-for="item in config.materials"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="select-wrap flex-1 flex">
        <div class="flex-1"></div>
        <div class="head flex">
          <div class="flex flex-align-center">
            <span
              @click="sort('time')"
              :class="{ active: opt.sort_by != 'price' }"
              >按时间排序</span
            >
            <img
              @click="sort('up')"
              v-if="opt.sort_by != 'price' && opt.sort_order != 1"
              src="@/assets/images/factory/sort_down.png"
            />
            <img
              @click="sort('down')"
              v-if="opt.sort_by != 'price' && opt.sort_order == 1"
              src="@/assets/images/factory/sort_up.png"
            />
          </div>
        </div>
      </div>
    </el-row>
    <div ref="load" class="list">
      <div v-if="list && list.length > 0" class="flex">
        <div
          v-for="item in list"
          :key="item.id"
          class="item-block"
          @click="toDetail(item.id)"
        >
          <img :src="imgUrl + item.photoRender[0] + '!width_250px'" />
          <div class="name">{{ item.name }}</div>
          <div class="feature">
            <span style="margin-right: 4px" v-if="item.style && item.style.name"
              >{{ item.style.name }} |</span
            >
            <span style="margin-right: 4px" v-if="item.cat && item.cat.name"
              >{{ item.cat.name }} |</span
            >
            {{ item.series && item.series.name }}
          </div>
          <div class="price">
            ¥{{ item.startPrice }}
            <span>起</span>
          </div>
          <!-- <div class="watch-count">
            已有{{ item.statistics && item.statistics.uv }}人查看
          </div> -->
          <div class="comp-info">
            <div class="tit">
              {{ item.factoryComp && item.factoryComp.name }}
            </div>
            <div class="style">
              <span>
                <i class="el-icon-medal"></i>
                {{ item.skuCount }}种款式
              </span>
              <span v-if="item.isProof" class="dayang">
                <b>
                  <i class="el-icon-check"></i>
                </b>
                已打样
              </span>
              <span v-else class="dayang">
                <b style="border: 1px solid #808080"> </b>
                未打样
              </span>
            </div>
            <div class="label">
              <label class="color-1">现货</label>
              <label class="color-2">高信用</label>
              <label class="color-3">低价</label>
            </div>
          </div>
        </div>
        <div style="position: absolute; bottom: 20px; right: 20px">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="queryOpt.page.pageNumber"
            :page-size="queryOpt.page.pageCount"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <div
        v-if="list && list.length == 0"
        class="flex flex-center"
        style="text-align: center; height: 500px"
      >
        <div>
          <img
            :src="staticUrl + '/design/placeholder/meiyougengduo.png'"
            alt=""
          />
          <div style="font-size: 20px; color: #808080; padding: 15px 0">
            暂无相关数据
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧提示栏 -->
    <FloatPanel></FloatPanel>
  </div>
</template>

<script>
import _ from "lodash";
import { getFactoryItems } from "@/service/mall";
import { IMG_URL_PRE, STATIC_URL_PRE } from "@/config";
import FloatPanel from "../Panel.vue";
import { getCats, getStyles, materialList } from "@/service/item";
import { fetchTree } from "@/util";
export default {
  components: {
    FloatPanel,
  },
  data() {
    return {
      catId: null,
      config: {
        styles: null, // 风格
        materials: null, // 材质
        cats: null, //类目
      },
      imgUrl: IMG_URL_PRE,
      staticUrl: STATIC_URL_PRE,
      opt: {
        sort_by: "", // 默认按发布时间排序，可以传price按价格排序
        sort_order: "", // 默认降序，传1表示升序
      },
      queryOpt: {
        where: {
          ids: null,
          key: null,
          catIds: null,
          compIds: null,
          priceType: [0, 2],
          isMaster: true,
        },
        page: {
          pageNumber: 1,
          pageCount: 16,
        },
        order: [["marketPublishedAt", "desc"]],
      },
      total: 0,
      list: null,
    };
  },
  watch: {
    queryOpt: {
      handler() {
        this.debounceRefreshItems();
      },
      deep: true,
    },
  },
  created() {
    const { query } = this.$route;
    if (query) {
      if (query.catId) {
        this.queryOpt.where.catIds = [query.catId];
      }
      if (query.search && query.search !== "") {
        this.queryOpt.where.key = query.search;
      }
    } else {
      this.refreshItems();
    }
    this.getBaseInfo();
    this.debounceRefreshItems = _.debounce(this.refreshItems, 500);
  },
  methods: {
    goCat(item) {
      this.catId = item.key;
      this.queryOpt.where.catIds = [item.key];
      this.debounceRefreshItems();
    },
    sort(type) {
      // 排序
      if (type == "time") {
        this.opt.sort_by = "";
        this.opt.sort_order = "";
      } else if (type == "price") {
        this.opt.sort_by = "price";
        this.opt.sort_order = "";
      } else if (type == "up") {
        this.opt.sort_order = 1;
        this.queryOpt.order = [["marketPublishedAt", "asc"]];
      } else if (type == "down") {
        this.opt.sort_order = "";
        this.queryOpt.order = [["marketPublishedAt", "desc"]];
      }
      this.refreshItems();
    },
    async getBaseInfo() {
      this.config.styles = await getStyles();
      this.config.materials = await materialList({ hasCommon: true });
      getCats().then((rst) => {
        this.config.cats = fetchTree(rst, null, {
          name: { dest: "title" },
          id: { dest: "key" },
          parent: "parentId",
        });
      });
    },
    toDetail(id) {
      this.$router.push(`/sale/mall/home/factory_detail/${id}`);
    },
    goto(path) {
      this.$router.push(path);
    },
    refreshItems() {
      // if (this.$route.query.catId) {
      //   this.queryOpt.where.catIds = [this.$route.query.catId];
      // }
      // if (this.$route.query.search) {
      //   this.queryOpt.where.key = this.$route.query.search;
      // }
      // if (this.$route.query.compId) {
      //   this.queryOpt.where.compIds = [this.$route.query.compId];
      // }
      this.list = null;
      const _loading = this.$loading({
        fullscreen: true,
        text: "拼命加载中....",
        target: this.$refs.load,
      });
      getFactoryItems(this.queryOpt)
        .then((rst) => {
          this.total = rst.count;
          this.list = rst.rows;
          console.log("getFactoryItems", this.list);
          _loading.close();
        })
        .catch((err) => {
          _loading.close();
          this.$message.error(err.message);
        });
    },
  },
};
</script>

<style scoped lang="less">
.container {
  width: 1200px;
  margin: 0 auto 40px;
}
.banner {
  height: 340px;
  width: 100%;
  img {
    height: 100%;
    width: 100%;
  }
}
.list {
  min-height: 800px;
  padding: 30px 30px 40px 30px;
  background-color: #fff;
  position: relative;
  .item-block {
    width: 264px;
    height: 482px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px 0px rgba(204, 204, 204, 1);
    padding: 20px;
    color: #808080;
    margin: 0 28px 30px 0;
    transform: scale(1);
    transition: all 0.3s;
    border: 1px solid transparent;
    &:hover {
      border: 1px solid rgba(80, 116, 238, 1);
      transform: scale(1.064);
    }
    &:nth-child(4n) {
      margin-right: 0;
    }
    cursor: pointer;
    img {
      width: 224px;
      height: 224px;
    }
    .name {
      color: #292929;
      font-size: 16px;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: 20px;
    }
    .feature {
      color: #808080;
      font-size: 12px;
      margin-top: 10px;
    }
    .price {
      color: #ee1818;
      font-size: 20px;
      margin-top: 10px;
      span {
        color: #808080;
        font-size: 12px;
      }
    }
    .watch-count {
      color: #b3b3b3;
      font-weight: 500;
      margin-top: 10px;
    }
    .label {
      margin-top: 10px;
      display: flex;
      label {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        border-radius: 2px;
        padding: 0 3px;
        margin-right: 9px;
        &.color-1 {
          color: #fff;
          background-color: #f66f6a;
        }
        &.color-2 {
          color: #5074ee;
          border: 1px solid #5074ee;
        }
        &.color-3 {
          color: #2bbaae;
          border: 1px solid #2bbaae;
        }
      }
    }
    .comp-info {
      margin-top: 10px;
      .tit {
        color: #292929;
        padding-top: 14px;
        border-top: 1px solid #ccc;
        font-weight: bold;
      }
      .style {
        font-size: 12px;
        margin-top: 10px;
        display: flex;
        span {
          margin-right: 18px;
          white-space: nowrap;
          display: flex;
          align-items: center;
          &:first-child {
            i {
              font-size: 14px;
            }
          }
        }
        .dayang {
          display: flex;
          align-items: center;
          white-space: nowrap;
          b {
            width: 12px;
            height: 12px;
            border: 1px solid #5074ee;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 6px;
            i {
              font-size: 14px;
              color: #5074ee;
            }
          }
        }
      }
    }
  }
}
</style>
